import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api, { directUrl } from "@/lib/api";
import GeneratedLinks from "@/components/GeneratedLinks";
import { Loader2, Box, FileQuestion } from "lucide-react";

export default function SharePage() {
  const { code } = useParams();
  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      try {
        const res = await api.get(`/images/${code}`);
        if (active) setImage(res.data);
      } catch {
        if (active) setError(true);
      } finally {
        if (active) setLoading(false);
      }
    })();
    return () => {
      active = false;
    };
  }, [code]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-40 text-muted-foreground">
        <Loader2 className="h-6 w-6 animate-spin" />
      </div>
    );
  }

  if (error || !image) {
    return (
      <div className="max-w-xl mx-auto px-4 py-32 text-center" data-testid="share-notfound">
        <div className="h-14 w-14 rounded-2xl bg-secondary flex items-center justify-center mx-auto mb-4">
          <FileQuestion className="h-6 w-6 text-muted-foreground" />
        </div>
        <h1 className="font-heading text-2xl font-bold tracking-tight">Image not found</h1>
        <p className="text-sm text-muted-foreground mt-2">This short link is invalid or the image was removed.</p>
        <Link to="/" className="inline-flex items-center gap-2 mt-6 text-sm font-medium text-accent hover:underline">
          <Box className="h-4 w-4" /> Back to ImageLink
        </Link>
      </div>
    );
  }

  return (
    <div className="dot-grid min-h-[calc(100vh-4rem)]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight mb-1" data-testid="share-title">
          {image.title}
        </h1>
        <p className="text-sm text-muted-foreground mb-8">Shared via ImageLink · {image.views} views</p>
        <GeneratedLinks image={image} />
      </div>
    </div>
  );
}
